export const getError = state => state.editParameter.get('error')
export const getIsSubmitting = state => state.editParameter.get('isSubmitting')
export const getIsAddingEmail = state => state.editParameter.get('isAddingEmail')
